module.exports = __webpack_public_path__ + "img/IMG_9695.d72fe2db.jpeg";